import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactGa from 'react-ga'
import CssBaseline from '@material-ui/core/CssBaseline'

import { ThemeProvider } from '@material-ui/core/styles'

import { Routing } from './components/Routing'
import { X_ACCESS_TOKEN_COOKIE_NAME } from './constants'
import * as actions from './actionTypes'
import RP_THEME from './theme.js'
import { getCookie } from './utils'

function App() {
  const dispatch = useDispatch()
  const { isAuthenticated, isInitialized: isAuthenticationInitialized } = useSelector(
    (state) => state.authentication
  )

  useEffect(() => {
    ReactGa.initialize('UA-109326169-14')
    dispatch({
      type: actions.AUTHENTICATION_CHECK,
      payload: { isAuthenticated: !!getCookie(X_ACCESS_TOKEN_COOKIE_NAME) },
    })
  }, [dispatch])

  return (
    <ThemeProvider theme={RP_THEME}>
      <CssBaseline />
      {isAuthenticationInitialized && (
        <>
          <Routing isAuthenticated={isAuthenticated} />
        </>
      )}
    </ThemeProvider>
  )
}

export default App
